import styled from 'styled-components';

import { Colors, Spacing } from '@lichtblick/theme';
import { Text } from '@lichtblick/ui-components';

export const Tagline = styled(Text)`
  color: ${Colors.Gray};
  margin-bottom: ${Spacing.Xxs};
`;
